<template>
  <div class="client-container">
    <Header />
    <div class="client-box">
      <div class="client-img-box">
        <img src="../../assets/home/clientBg.png" alt="">
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
export default {
  name: 'client',
  components: {
    Header,
    Footer
  },
  props: {},
  data() {
    return {

    }
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.client-container {
  padding-top: 80px;
  .client-box {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    background: url('../../assets/use-course/course-bg.png') no-repeat;
    background-size: 100% 528px;
    .client-img-box {
      width: 1200px;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }
    /*
    img {
      width: 1200px;
    }
    */
  }
}
</style>
